/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-23 16:26:01
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 19:00:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/AddReview/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Checkbox, Input, Rate, TextArea } from 'src/components/Antd';
import Uploader from 'src/components/Upload/Uploader';
import { useMultiImagesEffect } from 'src/components/Upload/hooks';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import CGroup from './ChannelGroup';
import {
  convertSaleToState,
  convertStateToSale,
  currentSelectedPub,
  getAllKeys,
  getSpecValues,
} from './tools';
// const _sales = [
//   {
//     channelType: 'type1',
//     name: 1,
//     uuid: '1',
//     locales: [
//       { isPrimary: false, top: false, publish: false, locale: 'English' },
//     ],
//   },
//   {
//     channelType: 'type2',
//     name: 2,
//     uuid: '2',
//     locales: [
//       { isPrimary: false, top: false, publish: false, locale: 'English' },
//       { isPrimary: false, top: false, publish: false, locale: '中文' },
//       { isPrimary: false, top: false, publish: false, locale: 'Korea' },
//     ],
//   },
//   {
//     channelType: 'type23',
//     name: 3,
//     uuid: '3',
//     locales: [
//       { isPrimary: false, top: false, publish: false, locale: 'English' },
//       { isPrimary: false, top: false, publish: false, locale: '中文' },
//     ],
//   },
// ];
const AddReview = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    medias,
    onCancel,
    onOk,
    // uuid: reviewUuid,
    rating: oriRate,
    title: oriTitle = '',
    content: oriContent = '',
    customerName: oriUsername = '',
    productReviewSalesChannels: oriLocales,
    ...rest
  } = props;

  const [rate, setRate] = React.useState(oriRate || 0);
  const [title, setTitle] = React.useState(oriTitle);
  const [titleErr, setTitleErr] = React.useState(false);
  const [content, setContent] = React.useState(oriContent);
  const [contentErr, setContentErr] = React.useState(false);
  const [username, setUsername] = React.useState(oriUsername);
  const [usernameErr, setUsernameErr] = React.useState(false);
  const [channels, setChannels] = React.useState(
    convertSaleToState(oriLocales || []),
  );
  const [fileList, setFileList] = React.useState(medias || []);

  useMultiImagesEffect(medias, fileList, setFileList);

  const totalKey = React.useMemo(() => {
    return getAllKeys(channels);
  }, [oriLocales]);

  const totalAmountOfKey = React.useMemo(() => {
    return totalKey.length;
  }, [totalKey]);

  const currentSelect = React.useMemo(
    () => currentSelectedPub(channels),
    [channels],
  );

  const currenAmountOfSelect = React.useMemo(
    () => currentSelect.length,
    [currentSelect],
  );

  const handleOnSelectAllChange = (e) => {
    const _channels = { ...channels };
    Object.keys(_channels).forEach((i) => {
      _channels[i].publish = e ? true : false;
      if (!e) {
        _channels[i].top = e;
      }
    });
    setChannels(_channels);
  };

  const handleOnSubPublishChannelChange = ({ keys }) => {
    const _channels = { ...channels };
    Object.keys(keys).forEach((i) => {
      const value = keys[i];
      _channels[i].publish = value;
      if (!value) {
        if (_channels[i].top) {
          _channels[i].top = value;
        }
        // _channels[i].top = value;
      }
    });
    setChannels(_channels);
  };

  const handleOnSubTopChannelChange = ({ keys }) => {
    const _channels = { ...channels };
    Object.keys(keys).forEach((i) => {
      const value = keys[i];
      _channels[i].top = value;
      if (value) {
        if (!_channels[i].publish) {
          _channels[i].publish = value;
        }
      }
    });
    setChannels(_channels);
  };

  const handleOnOk = () => {
    if (!title) {
      setTitleErr(true);
      return;
    }
    if (!content) {
      setContentErr(true);
      return;
    }
    if (!username) {
      setUsernameErr(true);
      return;
    }

    const productReviewSalesChannels = convertStateToSale({
      channel: channels,
      _sales: oriLocales,
    });
    const r = {
      ...rest,
      medias: fileList,
      rating: rate,
      title,
      content,
      customerName: username,
      productReviewSalesChannels,
    };
    if (onOk) onOk(r); //console.log(sales);
    //if (onOk) onOk(sales); //console.log(sales);
    // const _re = {};
  };

  const handleOnTitleChange = (e) => {
    setTitle(e);
    setTitleErr(false);
  };
  const handleOnContentChange = (e) => {
    setContent(e);
    setContentErr(false);
  };
  const handleOnUsernameChange = (e) => {
    setUsername(e);
    setUsernameErr(false);
  };
  return (
    <React.Fragment>
      <div className={css.container}>
        <ItemWrapper
          title={getI18n(
            'reviews.productreview.productReviewDetail_AddReview_genaral_Rating',
          )}>
          <div className={css.ratingContainer}>
            <Rate value={rate} onChange={setRate} />

            <span className={css.ratingTip}>{`${rate || 0} / 5`}</span>
          </div>
        </ItemWrapper>
        <ItemWrapper
          rightPart={<CountWords count={(title || '').length} allCount={300} />}
          title={getI18n(
            'reviews.productreview.productReviewDetail_AddReview_genaral_Review_Title',
          )}>
          <Input
            error={titleErr}
            size='large'
            maxLength={300}
            value={title}
            onChange={handleOnTitleChange}
          />
        </ItemWrapper>
        <ItemWrapper
          rightPart={
            <CountWords count={(content || '').length} allCount={1000} />
          }
          title={getI18n(
            'reviews.productreview.productReviewDetail_AddReview_genaral_Review_Content',
          )}>
          <TextArea
            error={contentErr}
            maxLength={1000}
            value={content}
            onChange={handleOnContentChange}
          />
        </ItemWrapper>

        <ItemWrapper
          rightSubTitle={getI18n(
            'reviews.productreview.productReviewDetail_AddReview_genaral_media_rightSubTitle',
          )}
          title={getI18n(
            'reviews.productreview.productReviewDetail_AddReview_genaral_media',
          )}>
          <div className={css.imagesContainer}>
            <Uploader
              multiple
              fileList={fileList}
              multipleSize={6}
              onChange={(file) => {
                setFileList(file);
              }}
              height={160}
              width={160}
              btnText={getI18n(
                'reviews.productreview.productReviewDetail_AddReview_genaral_media_btntext',
              )}
              ImageContainer={_ImageContainer}
              description={getI18n(
                'reviews.productreview.productReviewDetail_AddReview_genaral_media_description',
              )}
            />
            {/* {fileList.length>0&&<div>
              <UploaderPlaceholder/>
              </div>} */}
          </div>
        </ItemWrapper>
        <ItemWrapper
          bottomTitle={getI18n(
            'reviews.productreview.productReviewDetail_AddReview_genaral_Username_bottomTitle',
          )}
          title={getI18n(
            'reviews.productreview.productReviewDetail_AddReview_genaral_Username_title',
          )}>
          <Input
            error={usernameErr}
            size='large'
            value={username}
            onChange={handleOnUsernameChange}
            maxLength={30}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n(
            'reviews.productreview.productReviewDetail_AddReview_genaral_select_all',
          )}>
          <div className={css.selectedAllContainer}>
            <Checkbox
              indeterminate={
                currenAmountOfSelect > 0 &&
                currenAmountOfSelect < totalAmountOfKey
              }
              onChange={handleOnSelectAllChange}
              disabled={totalAmountOfKey === 0}
              checked={
                totalAmountOfKey === currenAmountOfSelect &&
                totalAmountOfKey !== 0
              }>
              {getI18n(
                'reviews.productreview.productReviewDetail_AddReview_genaral_select_all',
              )}
            </Checkbox>
          </div>

          {oriLocales.map((i) => {
            const { name, uuid, channelType, locales } = i;
            const _state = getSpecValues({ uuid, state: channels });
            return (
              <CGroup
                key={uuid}
                onTopChange={handleOnSubTopChannelChange}
                onPubChange={handleOnSubPublishChannelChange}
                locales={locales}
                data={_state}
                channelType={channelType}
                name={name}
                uuid={uuid}
              />
            );
          })}
        </ItemWrapper>
      </div>
      <ModalFooter
        okText={getI18n('general.publish')}
        onCancel={onCancel}
        onOk={handleOnOk}
      />
    </React.Fragment>
  );
};
export default AddReview;
const _ImageContainer = (props) => {
  const { index, children } = props;
  return (
    <div
      style={{
        width: 160,
        marginBottom: 16,
        marginRight: (index + 1) % 3 !== 0 ? 24 : 0,
      }}>
      {children}
    </div>
  );
};
